import React from "react";
import SimplePage from "../../components/legal/SimplePage";
import { useCurrency } from "../../context/CurrencyContext";

export default function Safety() {
  const { settings } = useCurrency();
  return <SimplePage eyebrow="Support" title="Safety" text={settings?.content_safety} loading={!settings?.content_safety} />;
}
